import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = {
  id: "form",
  class: "grid grid-cols-6 gap-6 mt-6"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 border-t border-gray-200" }, null, -1)
const _hoisted_3 = { class: "lg:col-span-2 md:col-span-3 col-span-6" }
const _hoisted_4 = { class: "lg:col-span-2 md:col-span-3 col-span-6" }
const _hoisted_5 = { class: "lg:col-span-2 md:col-span-3 col-span-6" }
const _hoisted_6 = { class: "lg:col-span-2 md:col-span-3 col-span-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "block text-xs font-semibold text-neutral-600" }, [
  /*#__PURE__*/_createTextVNode("Sex "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-600" }, "*")
], -1)
const _hoisted_8 = { class: "flex items-center md:pt-5 pt-2 space-x-6" }
const _hoisted_9 = { class: "lg:col-span-2 md:col-span-3 col-span-6" }
const _hoisted_10 = { class: "lg:col-span-2 md:col-span-3 col-span-6" }
const _hoisted_11 = { class: "lg:col-span-2 md:col-span-3 col-span-6" }

import TextInput from "@/components/inputs/TextInput.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import { ref, type PropType, computed, watch } from "vue";
import { renderSelectV2, renderSelect } from "@/interfaces/DropdownInterface";
import { GuardianCreate } from "@/interfaces/Cases/Guardian";
import { numberonly } from "@/components/composables/useNumberOnly";

import UserBirthdateAge from '@/components/forms/UserBirthdateAge.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: {
	form: {
		type: Object as PropType<GuardianCreate>,
		required: true,
	},
	errors: {
		type: Object,
		required: true,
	},
	genders: {
		type: [] as PropType<renderSelectV2>,
		default: [],
	},
	guardianRelationships: {
		type: [] as PropType<renderSelect>,
		default: [],
	},
},
  emits: ['update:form'],
  setup(__props, { expose: __expose, emit: __emit }) {

const birthdateForm = ref<any>(null);
const props = __props;

const emit = __emit;

const form = ref<GuardianCreate>(props.form);
__expose({ 
	form,
	birthdateForm,
})

watch(
    form.value,
    () => {
        emit('update:form', form.value);
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(TextInput, {
        type: "text",
        label: "Last Name",
        placeholder: "Last name",
        name: "last_name",
        id: "last_name",
        required: "",
        modelValue: form.value.last_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.last_name) = $event)),
        error: __props.errors?.last_name
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(TextInput, {
        type: "text",
        label: "First Name",
        placeholder: "First name",
        name: "first_name",
        id: "first_name",
        required: "",
        modelValue: form.value.first_name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.first_name) = $event)),
        error: __props.errors?.first_name
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(TextInput, {
        type: "text",
        label: "Middle Name",
        placeholder: "Middle name",
        name: "middle_name",
        id: "middle_name",
        modelValue: form.value.middle_name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.middle_name) = $event)),
        error: __props.errors?.middle_name
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(RadioGroup, {
          options: __props.genders,
          name: "gender",
          required: "",
          modelValue: form.value.gender,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.gender) = $event)),
          error: __props.errors?.gender
        }, null, 8, ["options", "modelValue", "error"])
      ]),
      (__props.errors?.gender)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass(["text-[10px] mt-1", __props.errors?.gender ? 'text-red-600' : 'text-gray-800']),
            id: "email-error"
          }, _toDisplayString(__props.errors?.gender), 3))
        : _createCommentVNode("", true)
    ]),
    _createVNode(UserBirthdateAge, {
      ref_key: "birthdateForm",
      ref: birthdateForm,
      form: form.value,
      errors: __props.errors,
      customClass: "lg:col-span-2 md:col-span-3 col-span-6"
    }, null, 8, ["form", "errors"]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(MultiSelect, {
        searchable: "",
        options: __props.guardianRelationships,
        id: "relationship",
        name: "relationship",
        label: "Relationship",
        placeholder: "Select..",
        required: "",
        modelValue: form.value.guardian_relationship_id,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.guardian_relationship_id) = $event)),
        error: __props.errors?.guardian_relationship_id
      }, null, 8, ["options", "modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(TextInput, {
        type: "text",
        label: "Other Relationship",
        placeholder: "Other Relationship",
        name: "other_relationship",
        id: "other_relationship",
        modelValue: form.value.other_relationship,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.other_relationship) = $event)),
        error: __props.errors?.other_relationship
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(TextInput, {
        type: "text",
        label: "Contacts",
        placeholder: "Contacts",
        name: "contacts",
        id: "contacts",
        add_on_left: true,
        add_on_text: "+63",
        maxlength: 10,
        onKeypress: _unref(numberonly),
        modelValue: form.value.contacts,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.contacts) = $event)),
        error: __props.errors?.contacts
      }, null, 8, ["onKeypress", "modelValue", "error"])
    ])
  ]))
}
}

})